// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"117":"0028ab3ca1fc312a","9665":"84ad0f351c52d6fe"}[chunkId] + ".js";
};